import React from "react"

const ProjectTemplateAvatarGrey = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7" cy="7" r="7" fill="#3C4260" />
    <path
      d="M6.5778 10.175H7.58156V5.40523H9.31286V4.56098H4.85039V5.40523H6.5778V10.175Z"
      fill="#F8F9FA"
    />
  </svg>
)

export default ProjectTemplateAvatarGrey
